import uuid from 'uuid/v4'
import {
  ADD_NOTIFICATION,
  CHANGE_NOTIFICATION_STATE,
  NOTIFICATION_STATE_CLOSING,
  NOTIFICATION_STATE_OPENING,
  NOTIFICATION_STATE_SHOWING,
  NOTIFICATION_TYPES,
  REMOVE_NOTIFICATION
} from './types'

export const state = {
  notifications: []
}

export const mutations = {
  [ADD_NOTIFICATION] (state, notification) {
    state.notifications = state.notifications.concat(notification)
  },
  [CHANGE_NOTIFICATION_STATE] (_, { notification, state }) {
    notification.state = state
  },
  [REMOVE_NOTIFICATION] (state, notification) {
    state.notifications = state.notifications.filter(n => n !== notification)
  }
}

export const actions = {
  addNotification ({
    commit,
    dispatch
  }, {
    message,
    type,
    duration = 10000,
    isRemoveable = true
  }) {
    if (!NOTIFICATION_TYPES.includes(type)) {
      const typesString = NOTIFICATION_TYPES.join(', ')
      throw new Error(`[notifications] invalid notification type. Use one of these: ${typesString}`)
    }

    const notification = {
      isRemoveable,
      message,
      state: NOTIFICATION_STATE_OPENING,
      type,
      uuid: uuid()
    }
    commit(ADD_NOTIFICATION, notification)
    if (duration > 0) {
      setTimeout(() => {
        dispatch('removeNotification', notification)
      }, duration)
    }
    return notification
  },
  removeNotification ({ commit }, notification) {
    commit(CHANGE_NOTIFICATION_STATE, { notification, state: NOTIFICATION_STATE_CLOSING })
    setTimeout(() => {
      commit(REMOVE_NOTIFICATION, notification)
    }, 800)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notifications/notifications.js